import { render, staticRenderFns } from "./BoxConfig.vue?vue&type=template&id=97995b0c&scoped=true&"
import script from "./BoxConfig.vue?vue&type=script&lang=js&"
export * from "./BoxConfig.vue?vue&type=script&lang=js&"
import style0 from "./BoxConfig.vue?vue&type=style&index=0&id=97995b0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97995b0c",
  null
  
)

export default component.exports